/* ============================================
   Compare-at price change on variation
   (existing code you already had)
   ============================================ */
(function() {
  function num(t){ return parseFloat((t||'').replace(/[^0-9.]/g,'')); }

  function refresh(box){
    var priceEl   = box.querySelector('[data-price]');
    var compareEl = box.querySelector('[data-compare-at-price]');
    if(!priceEl || !compareEl) return;

    var price   = num(priceEl.textContent);
    var compare = num(compareEl.textContent);

    if(!isNaN(price) && !isNaN(compare) && compare <= price){
      compareEl.style.display = 'none';
      box.querySelector('.price')?.classList.remove('price--sale');
    } else {
      compareEl.style.display = '';
      box.querySelector('.price')?.classList.add('price--sale');
    }
  }

  function init(){
    document.querySelectorAll('.price-ui[data-price-ui]').forEach(function(box){
      refresh(box);
      new MutationObserver(function(){ refresh(box); })
        .observe(box, {subtree:true, childList:true, characterData:true});
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===========================
   A11Y FIX 1: Clean bad aria-selected from non-widget elements
   Reason: theme/slider keeps re-adding aria-selected to plain divs
   =========================== */
(function () {
  // roles that are actually allowed to use aria-selected
  var ALLOWED_ROLES = [
    "option",
    "tab",
    "row",
    "gridcell",
    "treeitem",
    "menuitemradio"
  ];

  function cleanBadAriaSelected(root) {
    var selector =
      ".gallery-cell[aria-selected], .homepage-slideshow .gallery-cell[aria-selected], .logo-list__item[aria-selected]";
    var els = (root || document).querySelectorAll(selector);

    els.forEach(function (el) {
      var role = el.getAttribute("role");
      if (!role || ALLOWED_ROLES.indexOf(role) === -1) {
        el.removeAttribute("aria-selected");
      }
    });
  }

  // initial pass
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      cleanBadAriaSelected(document);
    });
  } else {
    cleanBadAriaSelected(document);
  }

  // watch for slider/nav re-applying aria-selected
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      // attribute change
      if (
        m.type === "attributes" &&
        m.attributeName === "aria-selected" &&
        m.target &&
        (m.target.classList.contains("gallery-cell") ||
          m.target.classList.contains("logo-list__item"))
      ) {
        var role = m.target.getAttribute("role");
        if (!role || ALLOWED_ROLES.indexOf(role) === -1) {
          m.target.removeAttribute("aria-selected");
        }
      }

      // new nodes
      if (m.type === "childList" && m.addedNodes.length) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            cleanBadAriaSelected(node);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ["aria-selected"]
  });
})();
/* ===========================
   END A11Y FIX 1
   =========================== */

/* ===========================
   A11Y FIX 2: De-duplicate nav submenu IDs
   Reason: Lighthouse flagged duplicate id="nav-tier-2-1"
   =========================== */
document.addEventListener("DOMContentLoaded", function () {
  var navLists = document.querySelectorAll('ul[id^="nav-tier-2-"]');
  var seen = {};

  navLists.forEach(function (ul, index) {
    var oldId = ul.id;

    if (seen[oldId]) {
      var newId = oldId + "-" + index;
      ul.id = newId;

      var trigger = document.querySelector('[aria-controls="' + oldId + '"]');
      if (trigger) {
        trigger.setAttribute("aria-controls", newId);
      }
    } else {
      seen[oldId] = true;
    }
  });
});
/* ===========================
   END A11Y FIX 2
   =========================== */

/* ===========================
   A11Y FIX 3: Make full-slide links safe visually
   Reason: stop accidental text from affecting layout
   =========================== */
document.addEventListener("DOMContentLoaded", function () {
  var fullLinks = document.querySelectorAll(".banner-full-link");
  fullLinks.forEach(function (link) {
    link.style.fontSize = "0";
    link.style.lineHeight = "0";
  });
});
/* ===========================
   END A11Y FIX 3
   =========================== */
/* #Footer-mobile-accordion-fix
   make new .footer-title headings toggle their content on mobile
================================================== */
document.addEventListener('DOMContentLoaded', function () {
  // select both the old pattern and the new one
  var footerTriggers = document.querySelectorAll(
    '.footer_menu h6, .footer_content h6, .footer_content .footer-title, .footer_menu .footer-title'
  );

  footerTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      // find the next toggle_content sibling
      var content = this.parentElement.querySelector('.toggle_content');
      if (!content) return;

      var isOpen = content.style.display === 'block';
      // close all in this column (optional)
      // this.parentElement.parentElement.querySelectorAll('.toggle_content').forEach(function (c) {
      //   c.style.display = 'none';
      // });

      content.style.display = isOpen ? 'none' : 'block';
      this.classList.toggle('is-open', !isOpen);
    });
  });
});
/* #Footer-mobile-accordion-fix END
================================================== */
